module.exports = __webpack_public_path__ + "img/kick_off.ae97e9db.png";